import { ref } from 'vue'

const isSnackbarActive = ref(false)
const snackbarMessage = ref('')
const snackbarColor = ref<'success' | 'error' | 'info' | 'warning'>('info')

export function useSnackbar() {
  const showSnackbar = (message: string, color: 'success' | 'error' | 'info' | 'warning') => {
    snackbarMessage.value = message
    snackbarColor.value = color
    isSnackbarActive.value = true
  }

  const handleError = (error: any) => {
    const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred.'
    showSnackbar(`Error: ${errorMessage}`, 'error')
  }

  return {
    isSnackbarActive,
    snackbarMessage,
    snackbarColor,
    showSnackbar,
    handleError,
  }
}
